module.exports = __webpack_public_path__ + "media/images/cse-footer-3-01399a2968ac50d4b12d9073b492327b.png";